const viewAny = (permissions) => {
  return permissions.includes('read-company-types')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-company-types')
}

const update = (permissions, companyType) => {
  return hasPermission(permissions, 'update-company-types')
}

const deletee = (permissions, companyType) => {
  return hasPermission(permissions, 'delete-company-types')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  create,
  update,
  deletee,
  hasPermission,
};